<template>
  <div>
    <b-form-group label="License designation" :state="designationState" :invalid-feedback="designationFeedback"
                  description="Required for a new license. Medical, Adult Use, or both for a dual license.">
      <b-form-checkbox-group :checked="value.designation" :options="designations" :state="designationState"
                             name="manual-designation" @input="update('designation', $event)"/>
    </b-form-group>
    <b-form-group label="Business activity" :state="activityState" :invalid-feedback="activityFeedback"
                  description="Required for a new license. Retail browse lists only licenses with Retailer. Operator does not mean Retailer.">
      <b-form-checkbox-group :checked="value.business_types" :options="activities" :state="activityState"
                             name="manual-business-types" @input="update('business_types', $event)"/>
    </b-form-group>
  </div>
</template>

<script>
/**
 * Required designation and business-activity choices for a new manual license. Nothing is
 * preselected, so the administrator enters only what state or supplier evidence supports.
 */
export default {
  name: "RegistryClassificationFields",
  props: {
    value: {type: Object, required: true},
    designations: {type: Array, default: () => []},
    activities: {type: Array, default: () => []},
    serverErrors: {type: Object, default: () => ({})},
    showValidation: {type: Boolean, default: false}
  },
  computed: {
    designationFeedback() {
      return this.feedback("designation", "Choose Medical, Adult Use, or both.");
    },
    activityFeedback() {
      return this.feedback("business_types", "Choose at least one business activity.");
    },
    designationState() {
      return this.designationFeedback ? false : null;
    },
    activityState() {
      return this.activityFeedback ? false : null;
    }
  },
  methods: {
    update(field, selected) {
      this.$emit("input", {...this.value, [field]: selected});
    },
    feedback(field, emptyMessage) {
      if (this.showValidation && !(this.value[field] || []).length) {
        return emptyMessage;
      }
      const key = Object.keys(this.serverErrors).find((name) => name === `fields.${field}` || name.startsWith(`fields.${field}.`));
      return key ? this.serverErrors[key][0] : "";
    }
  }
};
</script>
